<unity-page-container
  contentHeader="Manage Documents"
  [contentHeaderSecondary]="$contentHeaderSecondary()"
  [isLoading]="$isAgreementLoading()">
  <ng-container page-return> <unity-action-shared [action]="$returnToAgreementAction()" /></ng-container>
  <ng-container notifications />

  <ng-container actions>
    <unity-action-shared [action]="$createDocumentAction()" />
    <unity-action-shared [action]="$createReferenceFileAction()" />
  </ng-container>

  <unity-grid-document-schedule-shared [agreementId]="$agreementId()" />
  <unity-grid-reference-file-shared [agreementId]="$agreementId()" />
</unity-page-container>
